import {Component, computed, inject, input} from "@angular/core";
import {MatIcon} from "@angular/material/icon";
import {TranslocoPipe} from "@jsverse/transloco";
import {MetricComponentInputs} from "./metric";
import {LorenMetering} from "../loren-assets/interfaces/loren-metering.interface";
import {LorenAsset} from "../loren-assets/interfaces/loren-asset.interface";
import {LightboxService} from "../../common/lightbox/lightbox.service";

@Component({
    template: `
        @if (image(); as imageUrl) {
            <button type="button" class="open-photo" (click)="openLightbox(imageUrl)">
                <mat-icon>open_in_new</mat-icon>
                {{ 'asset.open_photo' | transloco }}
            </button>
        }
    `,

    styles: `
        .open-photo {
            display: inline-flex;
            align-items: center;
            gap: 4px;
            background: none;
            border: none;
            padding: 0;
            color: inherit;
            font: inherit;
            cursor: pointer;
        }

        mat-icon {
            font-size: 16px;
            width: 16px;
            height: 16px;
        }
    `,
    imports: [MatIcon, TranslocoPipe]
})
export class ImageSensorTable implements MetricComponentInputs {
    private lightbox = inject(LightboxService);

    asset = input.required<LorenAsset>();
    metric = input.required<LorenMetering>();
    image = computed(() => this.metric().data.find(x => x.key === 'imageUrl')?.value)

    openLightbox(imageUrl: string) {
        this.lightbox.open([imageUrl]);
    }
}